import axios from "axios";

const apiClient = axios.create({
    // baseURL: process.env.REACT_APP_API_URL || "http://localhost",
    baseURL:'/',
    timeout: 10000, // Set a timeout of 10 seconds
    headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
    },
});

apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error));

  
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
        // clear out bad tokens
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        // send user back to login
        window.location.replace("/login");
    }
    return Promise.reject(error);
  }
);  

export default apiClient;

